import { render, staticRenderFns } from "./_base-date-picker.vue?vue&type=template&id=4dbbd87c&scoped=true&"
import script from "./_base-date-picker.vue?vue&type=script&lang=js&"
export * from "./_base-date-picker.vue?vue&type=script&lang=js&"
import style0 from "./_base-date-picker.vue?vue&type=style&index=0&id=4dbbd87c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbbd87c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VTextField})
